import UserApi from '../api/mockUserApi';
import * as types from './actionTypes';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function loadUserSuccess(user) {
	return {type: types.LOAD_USER_SUCCESS, user: user};
}

export function loadUsersSuccess(users) {
	return {type: types.LOAD_USERS_SUCCESS, users: users};
}

export function loadUser() {
	return dispatch => {
		dispatch(beginAjaxCall());
		return UserApi.getInitialUser().then(user => {
			dispatch(loadUserSuccess(user));
		}).catch(error => {
			throw(error);
		});
	};
}

export function loadUsers() {
	return dispatch => {
		dispatch(beginAjaxCall());
		return UserApi.getAllUsers().then(users => {
			dispatch(loadUsersSuccess(users));
		}).catch(error => {
			throw(error);
		});
	};
}


/** WEBPACK FOOTER **
 ** ./src/actions/userActions.js
 **/